// import * as React from "react";
// import googleIcon from "../../../../../assets/images/google.svg";
// import SocialSignInButton from "../../../../../components/buttons/SocialSignInButton";
// import {
//   checkRefreshTokenWithServer,
//   verifyAuthTokenWithServer,
// } from "../../../../../services/accountApp/authService";
// import firebase from "../../../../../utils/firebase";
// import { removeAllCookies } from "../../../../../utils/cookies";

// export interface GoogleSignInProps {}
// const handleRefreshToken = async (idToken: any) => {
//   try {
//     const res = await checkRefreshTokenWithServer({ idToken });
//     return res?.status === 200;
//   } catch (error) {
//     return false;
//   }
// };

// const handleLogout = () => {
//   firebase
//     .auth()
//     .signOut()
//     .then(() => {
//       // Sign-out successful.
//       removeAllCookies();
//       localStorage.clear();
//       window.location.href = `${process.env.REACT_APP_PRESTO_ACCOUNT_DOMAIN}/accounts/sign-in`;
//     })
//     .catch((error) => {
//       console.error("error", error);
//     });
// };

// /* Google sign in page */
// const GoogleSignIn: React.FunctionComponent<GoogleSignInProps> = () => {
//   const [isLoading, setIsLoading] = React.useState(false);

//   const handleClick = () => {
//     setIsLoading(true);
//     const provider = new firebase.auth.GoogleAuthProvider();

//     firebase
//       .auth()
//       .signInWithPopup(provider)
//       .then((result: any) => {
//         if (result && result.user) {
//           firebase.auth().onAuthStateChanged((firebaseUser) => {
//             if (firebaseUser) {
//               firebaseUser.getIdToken(true).then(async function (idToken) {
//                 const isVerified = await handleRefreshToken(idToken);
//                 if (isVerified) {
//                   // Get the login details
//                   verifyAuthTokenWithServer(idToken, firebaseUser);
//                   const params = new URLSearchParams(window.location.search);
//                   const redirectUrl =
//                     params.get("redirectUrl") || "/accounts/apps";

//                   // Check if it's a full URL (external) or a relative path
//                   const isExternal = /^https?:\/\//i.test(redirectUrl);

//                   setTimeout(() => {
//                     setIsLoading(false);
//                     if (isExternal) {
//                       window.location.href = redirectUrl;
//                     } else {
//                       window.location.href = "/accounts/apps";
//                     }
//                   }, 2000);
//                 } else {
//                   handleLogout();
//                 }
//               });
//             }
//           });
//         }
//       })
//       .catch((error) => {
//         // Handle Errors here.
//         const errorCode = error.code;
//         const errorMessage = error.message;
//         // The email of the user's account used.
//         const { email } = error;
//         // The firebase.auth.AuthCredential type that was used.
//         const { credential } = error;
//         setIsLoading(false);
//       });
//   };
//   return (
//     <SocialSignInButton
//       handleClick={handleClick}
//       logoSrc={googleIcon}
//       labelText="Sign in with Google"
//       alt="google sign in"
//       isLoading={isLoading}
//     />
//   );
// };

// export default GoogleSignIn;

import * as React from "react";
import googleIcon from "../../../../../assets/images/google.svg";
import SocialSignInButton from "../../../../../components/buttons/SocialSignInButton";
import {
  checkRefreshTokenWithServer,
  verifyAuthTokenWithServer,
} from "../../../../../services/accountApp/authService";
import firebase from "../../../../../utils/firebase";
import { removeAllCookies } from "../../../../../utils/cookies";
export interface GoogleSignInProps {}
/* Google sign in page */
const GoogleSignIn: React.FunctionComponent<GoogleSignInProps> = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const handleRefreshToken = async (idToken: any) => {
    try {
      const res = await checkRefreshTokenWithServer({ idToken });
      return res?.status === 200;
    } catch (error) {
      return false;
    }
  };
  const handleLogout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        // Sign-out successful.
        removeAllCookies();
        localStorage.clear();
        window.location.href = `${process.env.REACT_APP_PRESTO_ACCOUNT_DOMAIN}/accounts/sign-in`;
      })
      .catch((error) => {
        console.error("error", error);
      });
  };
  const handleClick = () => {
    setIsLoading(true);
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result: any) => {
        if (result && result.user) {
          firebase.auth().onAuthStateChanged((firebaseUser) => {
            if (firebaseUser) {
              if (window.location.origin.includes("http://localhost")) {
                firebaseUser.getIdToken(true).then(async function (idToken) {
                  // Get the login details
                  verifyAuthTokenWithServer(idToken, firebaseUser);
                  setTimeout(() => {
                    setIsLoading(false);
                    window.location.href = "/accounts/apps";
                  }, 2000);
                });
              } else {
                firebaseUser.getIdToken(true).then(async function (idToken) {
                  const isVerified = await handleRefreshToken(idToken);
                  if (!isVerified) {
                    handleLogout();
                  } else {
                    // Get the login details
                    verifyAuthTokenWithServer(idToken, firebaseUser);

                    verifyAuthTokenWithServer(idToken, firebaseUser);

                    const params = new URLSearchParams(window.location.search);
                    const redirectUrl =
                      params.get("redirectUrl") || "/accounts/apps";

                    // Check if it's a full URL (external) or a relative path
                    const isExternal = /^https?:\/\//i.test(redirectUrl);
                    setTimeout(() => {
                      setIsLoading(false);
                      if (isExternal) {
                        window.location.href = redirectUrl;
                      } else {
                        window.location.href = "/accounts/apps";
                      }
                    }, 2000);
                  }
                });
              }
            }
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  return (
    <SocialSignInButton
      handleClick={handleClick}
      logoSrc={googleIcon}
      labelText="Sign in with Google"
      alt="google sign in"
      isLoading={isLoading}
    />
  );
};
export default GoogleSignIn;